import React from 'react';

// TODO: Simon do we need this?
export default function FormError({formErrors, fieldName}) {
  let isError = formErrors[fieldName].length > 0;
  let temporaryStyles = {
    float: "right",
    color: "#fab131",
    position: "absolute",
    right: 0
  };
  if (isError) {
    return (
      <p className="form-input__error" style={temporaryStyles}>
        {formErrors[fieldName]}
      </p>
    );
  } else {
    return null;
  }
}
